import React from 'react';
import classnames from 'classnames';
import { take } from '../../utils/fp';
import AvatarImage from '../../User/AvatarImage';
import s from './UserAvatarStack.scss';
var UserAvatarStack = function (_a) {
    var users = _a.users, className = _a.className, avatarClassName = _a.avatarClassName;
    return (React.createElement("div", { className: classnames(s['root'], users.length === 1 && s['only-one'], className) }, take(2, users).map(function (user, index) {
        var _a;
        return user.displayData.image && (React.createElement(AvatarImage, { alt: "", key: "user-" + user.id + "-" + index, src: (_a = user.displayData.image) === null || _a === void 0 ? void 0 : _a.url, className: classnames(s['avatar'], avatarClassName, users.length === 1 && s['only-one']), "aria-hidden": "true" }));
    })));
};
UserAvatarStack.displayName = 'UserAvatarStack';
export default UserAvatarStack;
//# sourceMappingURL=UserAvatarStack.js.map